<template>
  <n-config-provider :theme-overrides="themeOverrides" :locale="bxLocal">
    <n-message-provider>
      <n-dialog-provider>
        <router-view v-show="!initializing" />
      </n-dialog-provider>
    </n-message-provider>
    <div
      v-if="initializing"
      style="
      width: 100vw;
      height: 100vh;
      background: #fff;
      top: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    "
    >
      <n-spin size="large" />
    </div>
  </n-config-provider>
</template>

<script lang="ts" setup>
import {
  computed,
  ref,
} from "vue";
import { zhCN, GlobalThemeOverrides } from 'naive-ui'
import { useMainStore } from "@/store/main";
import { useEnvStore } from "@/store/env";
import { useRoute, useRouter } from "vue-router";

const mainStore = useMainStore()
const envStore = useEnvStore()
const router = useRouter();
const route = useRoute()

const initializing = computed(() => mainStore.initializing)

const themeOverrides: GlobalThemeOverrides = {
  common: {
    "primaryColor": "#2f528fFF",
    "primaryColorHover": "#2D86D3FF",
    "primaryColorPressed": "#0D46A0FF",
    "primaryColorSuppl": "#2D86D3FF",
    "successColor": "#2593F2FF",
    "successColorHover": "#2D86D3ff",
    "successColorPressed": "#0D46A0ff",
    "successColorSuppl": "#2D86D3ff",
  },
  Layout: {
    "headerColor": "#2f528fFF"
  }
}

const bxLocal = ref(zhCN)

const setMobile = () => {
  envStore.setMobile(document.documentElement.clientWidth <= 768)
  envStore.setSize(document.documentElement.clientWidth, document.documentElement.clientHeight)
}

setMobile()
window.onresize = () => {
  setMobile()
}
envStore.setUerAgent(navigator.userAgent)

</script>
